import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../core/config/config.service';

/**
 * Access-Token fuer die STOMP-CONNECT-Header. Eine Stelle fuer alle WebSocket-
 * Verbindungen des Frontends: der Kanal-Interceptor des Servers prueft jede
 * Verbindung gegen dasselbe Token, und zwei Ableitungen davon liefen beim
 * naechsten Scope-Wechsel auseinander.
 *
 * <p>Ohne angemeldetes Konto liefert der Aufruf {@code null} — die Verbindung geht
 * dann ohne Header hinaus und der Server weist sie ab. Das ist die ehrlichere
 * Reihenfolge als ein Fehler hier, weil der Aufrufer den Verbindungsverlust
 * ohnehin behandelt.
 */
@Injectable({ providedIn: 'root' })
export class StompAccessTokenService {
  private readonly msal = inject(MsalService, { optional: true });
  private readonly config = inject(ConfigService, { optional: true });

  async acquire(): Promise<string | null> {
    if (!this.msal || !this.config) {
      return null;
    }
    const account = this.msal.instance.getActiveAccount() ?? this.msal.instance.getAllAccounts()[0];
    if (!account) {
      return null;
    }
    try {
      const result = await firstValueFrom(
        this.msal.acquireTokenSilent({
          scopes: [`api://${this.config.azure.clientId}/access_as_users`],
          account,
        }),
      );
      return result.accessToken;
    } catch {
      return null;
    }
  }
}
